import { render } from "./CateSerie.vue?vue&type=template&id=4bcab372"
import script from "./CateSerie.vue?vue&type=script&lang=js"
export * from "./CateSerie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__